import React, { useEffect, useRef, useState } from "react";
import "./createpostpopup.scss";
import { CiImageOn, CiVideoOn } from "react-icons/ci";
import { FaTrash } from "react-icons/fa";
// import { BsLink45Deg } from "react-icons/bs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
	getSinglePostAPI,
	postUserPost,
	updateUserById,
	addNotificationAPI,
	getSearchResultsAPI,
	// getStartupByFounderId,
} from "../../../Service/user";
import { getBase64 } from "../../../utils/getBase64";
import FeedPostCard from "../../Investor/Cards/FeedPost/FeedPostCard";
import EasyCrop from "react-easy-crop";
import { s3 } from "../../../Service/awsConfig";
import {
	toggleCreatePostModal,
	selectTheme,
} from "../../../Store/features/design/designSlice";
import toast from "react-hot-toast";
import { loginSuccess } from "../../../Store/features/user/userSlice";
import IconFile from "../../Investor/SvgIcons/IconFile";
import { sharePostLinkedin, getUser, sendCommunityUpdate } from "../../../Service/user";
import { BiPoll } from "react-icons/bi";
import LinkedInLogin from "../../Login/LinkedinLogin/LinkedInLogin";
import { environment } from "../../../environments/environment";
import { useNavigate } from "react-router-dom";
import { Line } from "react-chartjs-2";

const IMAGE_MAX_SIZE_MB = 10; // 10MB
const DOCUMENT_MAX_SIZE_MB = 50; // 50MB
const VIDEO_MAX_SIZE_MB = 100; // 100MB

const stripHtmlTags = (html) => {
	const doc = new DOMParser().parseFromString(html, "text/html");
	const textContent = doc.body.textContent || "";
	return `${textContent}
  
          ---posted through TheCapitalHub(TheCapitalHub.in)`;
};

const debounce = (func, delay) => {
	let timer;
	return (...args) => {
	  clearTimeout(timer);
	  timer = setTimeout(() => func(...args), delay);
	};
};

const PollPopup = ({ onSave, initialOptions = ["", ""], onClose }) => {
	
	const [localPollOptions, setLocalPollOptions] = useState(initialOptions);
	const [allowMultipleAnswers, setAllowMultipleAnswers] = useState(true);

	const handleAddOption = () => {
		if (localPollOptions.length < 4) {
			setLocalPollOptions([...localPollOptions, ""]);
		}
	};

	const handleRemoveOption = (index) => {
		const newOptions = localPollOptions.filter((_, i) => i !== index);
		setLocalPollOptions(newOptions);
	};

	const handleOptionChange = (index, value) => {
		const newOptions = [...localPollOptions];
		newOptions[index] = value;
		setLocalPollOptions(newOptions);
	};

	const handleSave = () => {
		const validOptions = localPollOptions.filter((opt) => opt.trim() !== "");
		if (validOptions.length >= 2) {
			onSave(validOptions, allowMultipleAnswers);
			onClose();
		} else {
			toast.error("Please add at least 2 valid options");
		}
	};

	const handleAllowMultipleChange = () => {
		setAllowMultipleAnswers(!allowMultipleAnswers);
	};

	return (
		<>
			<div className="poll-popup-overlay" onClick={onClose} />
			<div className="poll-popup">
				<h3>Create Poll</h3>
				<div className="poll-options-container">
					{localPollOptions.map((option, index) => (
						<div key={index} className="poll-option-input">
							<input
								type="text"
								value={option}
								onChange={(e) => handleOptionChange(index, e.target.value)}
								placeholder={`Option ${index + 1}`}
								maxLength={100}
							/>
							{localPollOptions.length > 2 && (
								<button onClick={() => handleRemoveOption(index)}>×</button>
							)}
						</div>
					))}
				</div>
				<div className="allow-multiple-checkbox">
					<label>
						<input
							type="checkbox"
							checked={allowMultipleAnswers}
							onChange={handleAllowMultipleChange}
						/>
						Allow multiple answers
					</label>
				</div>
				<div className="poll-popup-buttons">
					{localPollOptions.length < 4 && (
						<button className="add-option" onClick={handleAddOption}>
							Add Option
						</button>
					)}
					<button className="save-poll" onClick={handleSave}>
						Save Poll
					</button>
				</div>
			</div>
		</>
	);
};

const CreatePostPopUp = ({
	setPopupOpen,
	popupOpen,
	setNewPost,
	respostingPostId,
	setRepostingPostId,
	appendDataToAllPosts,
	communityId,
	isInvestor,
	fromPostDetail,
}) => {
	const loggedInUser = useSelector((state) => state.user.loggedInUser);
	const navigate = useNavigate();
	const [postText, setPostText] = useState("");
	const [users, setUsers] = useState([]);
	const [category, setCategory] = useState("");
	const [shareOnLinkedIn, setShareOnLinkedIn] = useState(false);
	const [selectedImage, setSelectedImage] = useState(null);
	const [selectedVideo, setSelectedVideo] = useState(null);
	const [selectedDocument, setSelectedDocument] = useState(null);
	const [posting, setPosting] = useState(false);
	const [postType, setPostType] = useState("public");
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);
	const [allowMultipleAnswers, setAllowMultipleAnswers] = useState();
	const [showSuggestions, setShowSuggestions] = useState(false);
	const [suggestions, setSuggestions] = useState([]);
	const [mentionCharIndex, setMentionCharIndex] = useState(null);
	const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
	const baseUrl = environment.baseUrl;
	const [readinessData, setReadinessData] = useState(null);
	const [selectedReadinessType, setSelectedReadinessType] = useState('all');
	const [tractionData, setTractionData] = useState(null);

	const editorRef = useRef(null);

	useEffect(() => {
		// Check if there's an update summary in sessionStorage
		const updateSummary = sessionStorage.getItem('update_summary');
		const updateCommunityId = sessionStorage.getItem('update_community_id');
		const storedReadinessData = sessionStorage.getItem('readiness_data');
		const storedTractionData = sessionStorage.getItem('traction_data');
		if (updateSummary) {
			setPostText(updateSummary);
			sessionStorage.removeItem('update_summary');
		}
		
		if (storedReadinessData) {
			try {
				const parsedData = JSON.parse(storedReadinessData);
				setReadinessData(parsedData);
				sessionStorage.removeItem('readiness_data');
			} catch (error) {
				console.error('CreatePostPopUp - Error parsing readiness data:', error);
			}
		}

		if (storedTractionData) {
			try {
				const parsedData = JSON.parse(storedTractionData);
				setTractionData(parsedData);
				sessionStorage.removeItem('traction_data');
			} catch (error) {
				console.error('CreatePostPopUp - Error parsing traction data:', error);
			}
		}
		
		if (updateCommunityId && updateCommunityId !== '') {
			sessionStorage.removeItem('update_community_id');
		}
	}, []);

	const modules = {
		toolbar: [
			[{ header: [1, 2, 3, false] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ 'list': 'ordered'}, { 'list': 'bullet' }],
			['link', 'blockquote', 'code-block'],
			[{ 'color': [] }, { 'background': [] }],
			[{ 'align': [] }],
			['clean']
		],
	};

	const formats = [
		'header',
		'bold', 'italic', 'underline', 'strike',
		'list', 'bullet',
		'link', 'blockquote', 'code-block',
		'color', 'background',
		'align'
	];

	const fetchUsers = async (searchTerm) => {
		// Don't search if searchTerm is empty or too short
		if (!searchTerm || searchTerm.length < 1) {
			setSuggestions([]);
			return;
		}

		try {
			// Show loading indicator if needed
			setShowSuggestions(true);
			
			// Fetch users from the API endpoint
			const { data } = await getSearchResultsAPI(searchTerm);
			
			if (!data || !data.users) {
				console.error("Invalid data structure returned from API");
				setSuggestions([]);
				return;
			}

			// Filter users based on the search term
			const filteredUsers = data.users.filter((user) => 
				user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
				user.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
				user.userName?.toLowerCase().includes(searchTerm.toLowerCase())
			);

			// Update suggestions state with filtered users
			setSuggestions(filteredUsers);
		} catch (error) {
			console.error("Error fetching users:", error);
			setSuggestions([]);
		}
	};

	const debouncedFetchUsers = useRef(debounce(fetchUsers, 2000)).current;

	// const [croppedImage, setCroppedImage] = useState(null);
	const [pdfThumbnail, setPdfThumbnail] = useState(null);

	const [pollOptions, setPollOptions] = useState([]);

	// for multiple images
	const [selectedImages, setSelectedImages] = useState([]);
	const [previewImages, setPreviewImages] = useState([]);
	const [currentCropIndex, setCurrentCropIndex] = useState(0);
	const [croppedImages, setCroppedImages] = useState([]);

	const dispatch = useDispatch();
	const handleClose = () => {
		setPopupOpen(false);
		dispatch(toggleCreatePostModal());

		if(fromPostDetail){
			return
		}
		else{
		setRepostingPostId(""); // Clear the repostingPostId when closing
		}
	};

	const galleryInputRef = useRef(null);
	const documentInputRef = useRef(null);
	const cameraInputRef = useRef(null);

	const handleGalleryButtonClick = () => {
		galleryInputRef.current.click();
	};

	const handleDocumentButtonClick = () => {
		documentInputRef.current.click();
	};

	const handleCameraButtonClick = () => {
		cameraInputRef.current.click();
	};

	const [cropComplete, setCropComplete] = useState(false);
	const [previewVideo, setPreviewVideo] = useState("");
	const [previewVideoType, setPreviewVideoType] = useState("");

	const handleFileChange = async (event) => {
		const file = event.target.files[0];
		const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB

		// Check file size based on type
		if (event.target.name === "image" && fileSizeInMB > IMAGE_MAX_SIZE_MB) {
			alert(`Image size must be under ${IMAGE_MAX_SIZE_MB}MB`);
			return;
		} else if (event.target.name === "video" && fileSizeInMB > VIDEO_MAX_SIZE_MB) {
			alert(`Video size must be under ${VIDEO_MAX_SIZE_MB}MB`);
			return;
		} else if (event.target.name === "document" && fileSizeInMB > DOCUMENT_MAX_SIZE_MB) {
			alert(`Document size must be under ${DOCUMENT_MAX_SIZE_MB}MB`);
			return;
		}

		const objectUrl = URL.createObjectURL(file);

		const files = Array.from(event.target.files);
		if (event.target.name === "image") {
			// Check if adding new images would exceed the limit
			if (selectedImages.length + files.length > 5) {
				alert("You can only upload up to 5 images");
				return;
			}

			// Validate each image file
			const validImages = files.filter((file) => {
				const fileSizeInMB = file.size / (1024 * 1024);
				if (fileSizeInMB > IMAGE_MAX_SIZE_MB) {
					alert(
						`Image ${file.name} exceeds the maximum allowed size of ${IMAGE_MAX_SIZE_MB}MB.`
					);
					return false;
				}
				return file.type.includes("image");
			});

			if (validImages.length === 0) return;

			// Create object URLs for previews
			const newPreviewImages = validImages.map((file) =>
				URL.createObjectURL(file)
			);

			setSelectedImages((prev) => [...prev, ...validImages]);
			setPreviewImages((prev) => [...prev, ...newPreviewImages]);
			setSelectedVideo(null);
			setCroppedImages((prev) => [
				...prev,
				...Array(validImages.length).fill(null),
			]);

			// Start cropping from the first new image
			setCurrentCropIndex(selectedImages.length);
		} else if (event.target.name === "video" && file.type.includes("video")) {
			setPreviewVideoType(file.type);
			setPreviewVideo(objectUrl);
			setSelectedVideo(file);
			setSelectedImage(null);
			// setPdfThumbnail(null);
		} else if (event.target.name === "document") {
			setSelectedDocument(file);
			setSelectedImage(null);
			setSelectedVideo(null);
			// await renderPdfThumbnail(file);
		}
	};

	const handleQuillChange = (value, delta, source, editor) => {
		setPostText(value);

		if (source === "user") {
			const cursorPosition = editor.getSelection()?.index;
			if (cursorPosition !== undefined) {
				const content = editor.getText();
				const textBeforeCursor = content.slice(0, cursorPosition);
				
				// Find the last @ symbol before cursor
				const lastAtIndex = textBeforeCursor.lastIndexOf("@");
				
				if (lastAtIndex >= 0 && (lastAtIndex === 0 || content[lastAtIndex - 1] === ' ')) {
					const searchTerm = textBeforeCursor.slice(lastAtIndex + 1);
					setMentionCharIndex(lastAtIndex);
					
					// Always show suggestions and fetch users, even for empty search term
					setShowSuggestions(true);
					fetchUsers(searchTerm);
					
					// Position the dropdown
					if (editorRef.current) {
						const quill = editorRef.current.getEditor();
						const bounds = quill.getBounds(lastAtIndex);
						
						setDropdownPosition({
							top: bounds.top + bounds.height + 40,
							left: bounds.left,
						});
					}
				} else {
					// Hide suggestions if there's no @ or if there's a space after @
					setShowSuggestions(false);
					setMentionCharIndex(null);
				}
			}
		}
	};

	const handleSuggestionClick = (user) => {
		if (!editorRef.current || mentionCharIndex === null) return;
	
		const quill = editorRef.current.getEditor();
		quill.focus(); // Force focus
	
		setTimeout(() => {
			const currentSelection = quill.getSelection();
			if (!currentSelection) return;
	
			const currentPosition = currentSelection.index;
			const length = currentPosition - mentionCharIndex;
			quill.deleteText(mentionCharIndex, length);
	
			const mentionText = `@${user.userName}`;
			quill.insertText(mentionCharIndex, mentionText, {
				bold: true,
				color: '#FD5901',
				link: `/user/${user.userName}`
			});
			quill.insertText(mentionCharIndex + mentionText.length, ' ');
	
			const newPosition = mentionCharIndex + mentionText.length + 1;
			quill.setSelection(newPosition, 0);
	
			setShowSuggestions(false);
			setMentionCharIndex(null);
	
			quill.focus();
		}, 0); // Delay by one tick
	};
	

	// Function to handle profile navigation without inserting mention
	const handleProfileView = (user) => {
		window.open(`/user/${user.userName}`, '_blank');
	};

	const getCroppedImg = async (imageSrc, crop) => {
		const image = new Image();
		image.src = imageSrc;
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		canvas.width = crop.width;
		canvas.height = crop.height;
		ctx.drawImage(
			image,
			crop.x,
			crop.y,
			crop.width,
			crop.height,
			0,
			0,
			crop.width,
			crop.height
		);

		return new Promise((resolve, reject) => {
			canvas.toBlob(
				(blob) => {
					if (!blob) {
						reject(new Error("Failed to crop image"));
						return;
					}

					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onloadend = () => {
						resolve(reader.result);
					};
				},
				"image/jpeg",
				1
			);
		});
	};

	const onCropComplete = async (croppedArea, croppedAreaPixels) => {
		if (currentCropIndex !== null) {
			const croppedImg = await getCroppedImg(
				previewImages[currentCropIndex],
				croppedAreaPixels
			);
			setCroppedImages((prev) => {
				const newCroppedImages = [...prev];
				newCroppedImages[currentCropIndex] = croppedImg;
				return newCroppedImages;
			});
		}
	};

	const handleNextCrop = () => {
		if (currentCropIndex < selectedImages.length - 1) {
			setCurrentCropIndex((prev) => prev + 1);
		} else {
			setCurrentCropIndex(null);
			setCropComplete(true);
		}
	};

	// Function to remove an image
	const handleRemoveImage = (indexToRemove) => {
		setSelectedImages((prev) => prev.filter((_, i) => i !== indexToRemove));
		setPreviewImages((prev) => {
			// Revoke the URL to prevent memory leaks
			URL.revokeObjectURL(prev[indexToRemove]);
			return prev.filter((_, i) => i !== indexToRemove);
		});
		setCroppedImages((prev) => prev.filter((_, i) => i !== indexToRemove));

		// Adjust currentCropIndex if necessary
		if (currentCropIndex !== null) {
			if (indexToRemove === currentCropIndex) {
				// If we're removing the current image being cropped
				if (currentCropIndex >= selectedImages.length - 1) {
					// If it's the last image, complete cropping
					setCurrentCropIndex(null);
					setCropComplete(true);
				}
				// Otherwise keep the same index as it will now point to the next image
			} else if (indexToRemove < currentCropIndex) {
				// If we're removing an image before the current one, adjust the index
				setCurrentCropIndex((prev) => prev - 1);
			}
		}
	};

	const getProgressColor = (level) => {
		const percentage = (level / 5) * 100;
		if (percentage >= 80) return '#28a745';
		if (percentage >= 60) return '#ffc107';
		if (percentage >= 40) return '#fd7e14';
		return '#dc3545';
	};

	const renderReadinessSection = () => {
		if (!readinessData) {
			return null;
		}

		const types = selectedReadinessType === 'all' 
			? ['startup', 'team', 'business']
			: [selectedReadinessType];


		return (
			<div className="readiness-summary">
				<div className="readiness-type-selector">
					<select 
						value={selectedReadinessType} 
						onChange={(e) => setSelectedReadinessType(e.target.value)}
						className="form-select mb-3"
					>
						<option value="all">All Readiness Levels</option>
						<option value="startup">Startup Readiness</option>
						<option value="team">Team Readiness</option>
						<option value="business">Business Readiness</option>
					</select>
				</div>

				{types.map(type => {
					const data = readinessData[type];
					if (!data) return null;

					const questions = {
						startup: [
							{ key: 'clearProblemStatement', label: 'Clear Problem Statement' },
							{ key: 'minimumViableProduct', label: 'Minimum Viable Product' },
							{ key: 'definedTargetMarket', label: 'Target Market' },
							{ key: 'marketResearchValidation', label: 'Market Research' },
							{ key: 'clearRevenueModel', label: 'Revenue Model' }
						],
						team: [
							{ key: 'completeFoundingTeam', label: 'Founding Team' },
							{ key: 'relevantIndustryExperience', label: 'Industry Experience' },
							{ key: 'definedRolesResponsibilities', label: 'Roles & Responsibilities' },
							{ key: 'advisorsAndMentors', label: 'Advisors & Mentors' },
							{ key: 'hiringAndScalingPlan', label: 'Hiring & Scaling Plan' }
						],
						business: [
							{ key: 'detailedBusinessPlan', label: 'Business Plan' },
							{ key: 'keyMetricsForSuccess', label: 'Key Metrics' },
							{ key: 'financialProjections', label: 'Financial Projections' },
							{ key: 'keyPartnershipsResources', label: 'Key Partnerships' },
							{ key: 'clearCompetitiveAdvantage', label: 'Competitive Advantage' }
						]
					};

					return (
						<div key={type} className="readiness-type-section mb-4">
							<h4 className="text-capitalize">{type} Readiness</h4>
							<div className="progress-summary mb-3">
								<div className="progress-bar" 
									style={{
										backgroundColor: getProgressColor(data.readinessLevel),
										width: `${(data.readinessLevel / 5) * 100}%`,
										height: '20px',
										borderRadius: '10px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										color: '#fff'
									}}>
									{data.readinessLevel}/5
								</div>
								<p className="mt-2">{data.readinessDescription}</p>
							</div>

							<div className="answers-section">
								{questions[type].map(({ key, label }) => {
									if (!data[key]) return null;
									return (
										<div key={key} className="answer-item mb-2">
											<strong>{label}:</strong> {data[key]}
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setPosting(true);


		if (!selectedImages.length && !selectedVideo && !selectedDocument) {
			if (!respostingPostId && !postText && !readinessData) {
				return setPosting(false);
			}
		}

		try {
			const postData = new FormData();
			if (respostingPostId) {
				postData.append("resharedPostId", respostingPostId);
			}
			postData.append("description", postText);
			postData.append("category", category);
			
			// Add readiness data if available
			if (readinessData) {
				const readinessPayload = {
					type: selectedReadinessType,
					...readinessData
				};
				// Instead of JSON.stringify, append each field individually
				Object.entries(readinessPayload).forEach(([key, value]) => {
					if (typeof value === 'object') {
						Object.entries(value).forEach(([subKey, subValue]) => {
							postData.append(`readinessUpdate[${key}][${subKey}]`, subValue);
						});
					} else {
						postData.append(`readinessUpdate[${key}]`, value);
					}
				});
			}

			// Add traction data if available
			if (tractionData && tractionData.update) {
				// Append each field individually to maintain the structure
				tractionData.update.forEach((update, index) => {
					postData.append(`tractionUpdate[update][${index}][date]`, update.date);
					postData.append(`tractionUpdate[update][${index}][revenue]`, update.revenue);
					postData.append(`tractionUpdate[update][${index}][users]`, update.users);
				});
				postData.append('tractionUpdate[allUsers]', tractionData.allUsers || 0);
			}

			if (croppedImages.length === 1) {
				postData.append("image", croppedImages[0]);
			}
			if (croppedImages.length > 1) {
				croppedImages.forEach((image, index) => {
					if (image) {
						postData.append(`images[${index}]`, image);
					}
				});
			}

			if (selectedVideo) {
				const video = await getBase64(selectedVideo);
				postData.append("video", video);
			}

			if (selectedDocument) {
				const timestamp = Date.now();
				const fileName = `${timestamp}_${selectedDocument.name}`;
				const params = {
					Bucket: "thecapitalhubwebsitedocuments",
					Key: `documents/${fileName}`,
					Body: selectedDocument,
				};
				const res = await s3.upload(params).promise();
				postData.append("documentUrl", res.Location);
				postData.append("documentName", selectedDocument.name);
				postData.append("image", res.Location);
			}
			if (pollOptions.length > 0) {
				const validOptions = pollOptions.filter(
					(option) => option.trim() !== ""
				);
				validOptions.forEach((option, index) => {
					postData.append(`pollOptions[${index}]`, option);
				});
				postData.append(`allow_multiple_answers`, allowMultipleAnswers);
			}

			// Check if there's a stored community ID in sessionStorage
			const storedCommunityId = sessionStorage.getItem('update_community_id');
			
			if (communityId || storedCommunityId) {
				postData.append("postType", "community");
				postData.append("communityId", communityId || storedCommunityId);
				// Clear the stored ID after using it
				if (storedCommunityId) {
					sessionStorage.removeItem('update_community_id');
				}
			} else {
				postData.append("postType", postType);
			}

			const response = await postUserPost(postData);
			const newPosts = Array.isArray(response.data)
				? response.data
				: [response.data];
			appendDataToAllPosts(response.data);
			const s3ImageUrl = response.data.image;

			const linkedinText = stripHtmlTags(postText);

			// Check if sharing on LinkedIn
			if (shareOnLinkedIn) {
				const linkedInApiData = {
					owner: `urn:li:person:${loggedInUser.linkedinId}`,
					text: {
						text: linkedinText,
					},
					s3ImageUrl: s3ImageUrl,
					linkedInPostData: {
						owner: `urn:li:person:${loggedInUser.linkedinId}`,
						text: {
							text: linkedinText,
						},
					},
					token: loggedInUser.linkedinToken,
				};

				// LinkedIn API call
				await sharePostLinkedin(linkedInApiData);
			}

			// If this is a community post, send update notification
			if (communityId || storedCommunityId) {
				await sendCommunityUpdate({
					communityId: communityId || storedCommunityId,
					updateType: "Post",
					description: "A new post has been shared in the community."
				});
			}

			// Reset all states
			setPostText("");
			setSelectedImages([]);
			setPreviewImages([]);
			setCroppedImages([]);
			setSelectedVideo(null);
			setSelectedDocument(null);
			setCropComplete(false);
			setCurrentCropIndex(null);
			if(!communityId && !storedCommunityId){
			setNewPost(Math.random());
			}
			handleClose();

			// Handle achievements
			if (!loggedInUser.achievements.includes("6564684649186bca517cd0c9")) {
				const achievements = [...loggedInUser.achievements];
				achievements.push("6564684649186bca517cd0c9");
				const updatedData = { achievements };
				const { data } = await updateUserById(loggedInUser._id, updatedData);
				dispatch(loginSuccess(data.data));
				const notificationBody = {
					recipient: loggedInUser._id,
					type: "achievementCompleted",
					achievementId: "6564684649186bca517cd0c9",
				};
				await addNotificationAPI(notificationBody);
			}

		} catch (error) {
			console.error("Error submitting post:", error);
			toast.error("Error creating post. Please try again.");
		} finally {
			setPosting(false);
		}
	};

	const [repostingPostData, setRepostingPostData] = useState(null);
	const [loadingRepostData, setLoadingRepostData] = useState(false);

	useEffect(() => {
		if (respostingPostId) {
			setLoadingRepostData(true);
			getSinglePostAPI(respostingPostId)
				.then(({ data }) => {
					setRepostingPostData(data);
					setLoadingRepostData(false);
				})
				.catch(() => handleClose());
		}
	}, [respostingPostId]);

	const [showPollPopup, setShowPollPopup] = useState(false);

	const [linkedinError, setLinkedinError] = useState(null);

	const handleLinkedInLoginSuccess = () => {
		// Handle successful LinkedIn login
		// You can set any state or perform actions needed after successful login
	};

	const handleLinkedInLoginError = (error) => {
		// Handle LinkedIn login error
		setLinkedinError(error);
	};

	// Add aspect ratio constraint
	const ASPECT_RATIO = 1;

	useEffect(() => {
		// Function to handle window resize and adjust dropdown position
		const handleResize = () => {
			if (showSuggestions && mentionCharIndex !== null && editorRef.current) {
				const quill = editorRef.current.getEditor();
				const bounds = quill.getBounds(mentionCharIndex);
				
				setDropdownPosition({
					top: bounds.top + bounds.height + 40,
					left: bounds.left,
				});
			}
		};

		// Add event listener for window resize
		window.addEventListener('resize', handleResize);
		
		// Clean up
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [showSuggestions, mentionCharIndex]);

	const renderTractionChart = () => {
		
		if (!tractionData || !tractionData.update || tractionData.update.length === 0) {
			return null;
		}

		const chartData = {
			labels: tractionData.update.map(u => {
				const date = new Date(u.date);
				return date.toLocaleString('default', { month: 'short', year: 'numeric' });
			}),
			datasets: [
				{
					label: 'Revenue',
					data: tractionData.update.map(u => u.revenue),
					borderColor: 'rgb(75, 192, 192)',
					tension: 0.1
				},
				{
					label: 'Users',
					data: tractionData.update.map(u => u.users),
					borderColor: 'rgb(255, 99, 132)',
					tension: 0.1
				}
			]
		};

		return (
			<div className="traction-chart-section">
				<h4>Traction Metrics</h4>
				<div className="chart-container">
					<Line data={chartData} />
					<div className="metrics-summary">
						<div className="metric">
							<h4>Total Users</h4>
							<p>{tractionData.allUsers}</p>
						</div>
						<div className="metric">
							<h4>Latest Revenue</h4>
							<p>{tractionData.update[tractionData.update.length - 1]?.revenue}</p>
						</div>
					</div>
				</div>
			</div>
		);
	};

	return (
		<>
			{popupOpen && <div className="createpost__overlay"></div>}
			<div
				className={`createpost__popup ${popupOpen ? "d-block" : ""}`}
				tabIndex="-1"
				role="dialog"
			>
				<div className="createpost__container">
					<div className="createpost__header">
						<div className="ceatepost__profile">
							<img
								src={loggedInUser.profilePicture}
								width={50}
								height={50}
								style={{ objectFit: "cover" }}
								className="rounded-circle"
								alt="profile pic"
							/>
							<span>
								<h2>
									{loggedInUser?.firstName} {loggedInUser.lastName}
								</h2>
								{!communityId && (
									<div style={{ display: "flex", width: "110px", justifyContent: "space-between" }}>
										<h6
											className=""
											style={{
												backgroundColor: isInvestor && postType === "public" ? "rgb(211, 243, 107)" : postType === "public" && "#fd5901",
												color: isInvestor && postType === "public" ? "#000" : postType === "public" ? "#fff" : "grey",
												padding: "1px 2px",
												borderRadius: "2px",
												cursor: "pointer",
											}}
											onClick={() => setPostType("public")}
										>
											Public
										</h6>
										<h6
											style={{
												backgroundColor: postType === "company" && "rgb(211, 243, 107)",
												color: postType === "company" ? "#000" : "grey",
												padding: "1px 2px",
												borderRadius: "2px",
												cursor: "pointer",
											}}
											onClick={() => setPostType("company")}
										>
											Company
										</h6>
									</div>
								)}
							</span>
						</div>

						<button
							type="button"
							className="close d-flex justify-content-end"
							onClick={handleClose}
							style={{ background: "transparent", border: "none" }}
						>
							<h3 aria-hidden="true" className="m-3">
								&times;
							</h3>
						</button>
					</div>
					<div className="createpost__body__footer">
						<div className="createpost__body">
							<ReactQuill
								ref={editorRef}
								theme="snow"
								value={postText}
								onChange={handleQuillChange}
								modules={modules}
								formats={formats}
								placeholder="What's on your mind?"
								className="custom-quill-post"
							/>

							{renderReadinessSection()}
							{renderTractionChart()}

							{showSuggestions && suggestions.length > 0 && (
								<div
									className="user-suggestions-dropdown"
									style={{
										position: 'absolute',
										top: `${dropdownPosition.top + 10}px`,
										left: `${dropdownPosition.left}px`,
										zIndex: 9999,
										backgroundColor: 'var(--white-to-grey)',
										border: '1px solid var(--bs-border-color)',
										borderRadius: '4px',
										boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
										maxHeight: '200px',
										overflow: 'auto',
										width: '250px',
										maxWidth: '90%',
										transform: 'translateY(10px)', // Offset slightly to avoid overlapping text
										pointerEvents: 'auto' // Ensure it captures mouse events
									}}
									onClick={(e) => e.stopPropagation()} // Prevent clicks from reaching underlying elements
								>
									{suggestions.length === 0 ? (
										<div style={{ padding: '10px', color: 'var(--d-l-grey)', textAlign: 'center' }}>
											No users found
										</div>
									) : (
										suggestions.map((user) => (
											<div
												key={user._id}
												className="suggestion-item"
												style={{ 
													padding: '8px 12px',
													cursor: 'pointer',
													display: 'flex',
													alignItems: 'center',
													borderBottom: '1px solid var(--bs-border-color)',
													transition: 'background-color 0.2s',
													justifyContent: 'space-between',
													pointerEvents: 'auto'
												}}
												onClick={(e) => {
													e.preventDefault();
													handleSuggestionClick(user);
												}}
												onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--bs-border-color)'}
												onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
											>
												<div 
													style={{ 
														display: 'flex', 
														alignItems: 'center', 
														flex: 1,
														pointerEvents: 'auto'
													}}
													onClick={(e) => {
														e.stopPropagation();
														handleSuggestionClick(user);
													}}
												>
													{user.profilePicture && (
														<img 
															src={user.profilePicture} 
															alt={user.firstName}
															style={{ 
																width: '30px', 
																height: '30px', 
																borderRadius: '50%', 
																marginRight: '10px',
																objectFit: 'cover'
															}} 
														/>
													)}
													<div>
														<div style={{ fontWeight: 'bold', color: 'var(--d-l-grey)' }}>
															{user.firstName} {user.lastName}
														</div>
														{user.userName && (
															<div style={{ fontSize: '12px', color: 'var(--d-l-grey)', opacity: 0.8 }}>
																@{user.userName}
															</div>
														)}
													</div>
												</div>
												<button
													style={{
														background: '#FD5901',
														color: 'white',
														border: 'none',
														borderRadius: '4px',
														padding: '3px 8px',
														fontSize: '12px',
														cursor: 'pointer',
														pointerEvents: 'auto'
													}}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation(); // Prevent the click from triggering the parent div's onClick
														handleProfileView(user);
													}}
												>
													View
												</button>
											</div>
										))
									)}
								</div>
							)}

							{respostingPostId &&
								(loadingRepostData ? (
									<div className="d-flex justify-content-center my-4">
										<h6 className="h6 me-4">Loading post...</h6>
										<div className="spinner-border" role="status">
											<span className="visually-hidden">Loading...</span>
										</div>
									</div>
								) : (
									<div className="repost-preview-container">
										<button 
											className="remove-repost-btn" 
											onClick={() => setRepostingPostId("")}
											title="Remove repost"
										>
											<FaTrash/>
										</button>
										<FeedPostCard
											repostPreview
											userId={repostingPostData?.user?._id}
											postId={repostingPostData?._id}
											designation={repostingPostData?.user?.designation}
											profilePicture={repostingPostData?.user?.profilePicture}
											description={repostingPostData?.description}
											firstName={repostingPostData?.user?.firstName}
											lastName={repostingPostData?.user?.lastName}
											video={repostingPostData?.video}
											image={repostingPostData?.image}
											createdAt={repostingPostData?.createdAt}
											likes={repostingPostData?.likes}
										/>
									</div>
								))}
							{previewImages.length > 0 && currentCropIndex !== null && (
								<div className="d-flex flex-column justify-content-center gap-2 image-cropper-container-absolute">
									<div className="image-cropper">
										<EasyCrop
											image={previewImages[currentCropIndex]}
											crop={crop}
											zoom={zoom}
											onCropChange={setCrop}
											onZoomChange={setZoom}
											onCropComplete={onCropComplete}
											aspect={ASPECT_RATIO}
											cropShape="rect"
										/>
									</div>
									<div className="d-flex justify-content-between align-items-center">
										<span>
											Image {currentCropIndex + 1} of {selectedImages.length}
										</span>
										<button
											className="btn btn-primary btn-sm"
											onClick={handleNextCrop}
										>
											{currentCropIndex < selectedImages.length - 1
												? "Next Image"
												: "Finish Cropping"}
										</button>
									</div>
								</div>
							)}
						</div>
						<div className="d-flex justify-content-between align-items-start">
							{cropComplete && (
								<div className="image-preview-grid">
									{croppedImages.map((img, index) => (
										<div key={index} className="image-preview-item">
											<img
												src={img}
												alt={`preview ${index + 1}`}
												style={{
													maxHeight:
														selectedImages.length > 1 ? "15vh" : "15vh",
													width: "auto",
													objectFit: "contain",
												}}
											/>
											<button
												className="remove-image-btn"
												onClick={() => handleRemoveImage(index)}
											>
												×
											</button>
										</div>
									))}
								</div>
							)}

							{previewVideo && (
								<video
									key={selectedVideo ? selectedVideo.name : ""}
									controls
									// width={"70%"}
									className="video-preview"
								>
									<source src={previewVideo} type={previewVideoType} />
									Your browser does not support the video tag.
								</video>
							)}
						</div>
						{pdfThumbnail && (
							<div className="pdf-thumbnail">
								<img
									src={pdfThumbnail}
									alt="PDF Thumbnail"
									style={{ maxHeight: "30vh", width: "auto" }}
								/>
							</div>
						)}

						{selectedDocument && !pdfThumbnail && (
							<p>Selected File: {selectedDocument.name}</p>
						)}
					</div>

					<div className="createpost__footer">
						{(loggedInUser.linkedinId && loggedInUser.linkedinToken) ? (

						(!communityId &&	<div className="share-linkedin">
								<input
									type="checkbox"
									id="shareLinkedIn"
									checked={shareOnLinkedIn}
									onChange={() => setShareOnLinkedIn((prev) => !prev)}
								/>
								<label htmlFor="shareLinkedIn">Share on LinkedIn</label>
							</div>)
						) : (
							(!communityId && <div className="mt-1 mb-1">
								<LinkedInLogin
									isInvestorSelected={false}
									setIsLoginSuccessfull={handleLinkedInLoginSuccess}
									setIsInvestorSelected={() => {}}
									setError={handleLinkedInLoginError}
									text={"Connect"}
									showIconAndText={true}
									REDIRECT_URI={"https://thecapitalhub.in/home"}
								/>
							</div>)
						)}
						<div className="createpost__footer__container mt-2 mb-1">
							<div className="left_buttons">
								<input
									type="file"
									name="image"
									style={{ display: "none" }}
									ref={galleryInputRef}
									onChange={handleFileChange}
									accept="image/*"
								/>
								<button
									className={`white_button hover-text ${isInvestor ? "investor" : ""}`}
									onClick={handleGalleryButtonClick}
								>
									<CiImageOn size={25} style={{ color: "var(--d-l-grey)" }} />
									<span className="tooltip-text top">images</span>
								</button>

								<input
									type="file"
									name="video"
									style={{ display: "none" }}
									ref={cameraInputRef}
									onChange={handleFileChange}
									accept="video/*"
								/>
								<button
									className={`white_button hover-text ${isInvestor ? "investor" : ""}`}
									onClick={handleCameraButtonClick}
								>
									<CiVideoOn size={25} style={{ color: "var(--d-l-grey)" }} />
									<span className="tooltip-text top1">video</span>
								</button>

								<input
									type="file"
									name="document"
									style={{ display: "none" }}
									ref={documentInputRef}
									onChange={handleFileChange}
								/>
								<button
									className={`white_button hover-text ${isInvestor ? "investor" : ""}`}
									onClick={handleDocumentButtonClick}
								>
									<IconFile
										width="16px"
										height="16px"
										style={{ color: "var(--d-l-grey)" }}
									/>
									<span className="tooltip-text top2">doc</span>
								</button>
								<button
									className={`white_button hover-text ${isInvestor ? "investor" : ""}`}
									onClick={() => setShowPollPopup(true)}
								>
									<BiPoll size={25} style={{ color: "var(--d-l-grey)" }} />
									<span className="tooltip-text top3">poll</span>
								</button>
							</div>
							<div className="post_button_container">
								{posting ? (
									<button className={`post_button ${communityId? ("community-color") : (" ")} ${isInvestor ? "investor" : ""}`}
									disabled>
										Posting...
									</button>
								) : (
									<button
										className={`post_button ${communityId? ("community-color") : (" ")} ${isInvestor ? "investor" : ""}`}
										onClick={handleSubmit}
										disabled={posting}
									>
										Post
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{showPollPopup && (
				<PollPopup
					initialOptions={pollOptions}
					onSave={(newOptions, allowMultipleAnswers) => {
						setAllowMultipleAnswers(allowMultipleAnswers);
						setPollOptions(newOptions);
					}}
					onClose={() => setShowPollPopup(false)}
				/>
			)}
			{linkedinError && <div className="error-message">{linkedinError}</div>}
		</>
	);
};

export default CreatePostPopUp;

